import React, {Fragment, useState} from 'react';
import './FAQInvest.css';
import eyeclose from "../../../static/img/Invest/eyeclose.svg";
import eyeopen from "../../../static/img/Invest/eyeopen.svg";

let ButtonInvestVisibleAllLet = 'InvestFAQButtonButtonAllDivActiveNo';
let ButtonInvestVisibleNoLet = 'InvestFAQButtonButtonAllDivActive';

function InvestFAQElements(props){

    const [stateArrayFAQ, setstateArrayFAQ] = useState(props.AllFAQElements);
    const [VisibleCloseButton, setVisibleCloseButton] = useState(ButtonInvestVisibleAllLet);
    const [VisibleOpenButton, setVisibleOpenButton] = useState(ButtonInvestVisibleNoLet);
    const [forRerender, setRerender] = useState('');

    function FAQCategory(AllFAQCatArr) {
        const listItemsCat = Object.keys(AllFAQCatArr).map((number) =>
            <div key={number} className="TraderFAQSection">
                <div className={"StandartH2"}>{JSON.parse(AllFAQCatArr[number].Name)[props.lang]}</div>
                {FAQElement(stateArrayFAQ,AllFAQCatArr[number].Elements)}
            </div>
        );
        return (
            <Fragment>{listItemsCat}</Fragment>

        )}

    function FAQElement(AllFAQArr,Elements) {
        const listItems = Elements.map((number) =>
            <div key={number._id}>
                <div className={"InvestFAQPartElement "+ (stateArrayFAQ[number._id] ? 'InvestFAQPartElementActive' : '')} onClick={() => MakeVisibleThis(number._id)} role="button" tabIndex={0} onKeyPress={() => {}}>
                    <span className="InvestFAQPartElementTitle">{JSON.parse(number.Title)[props.lang]}</span>
                    <div className="InvestFAQPartElementText">{JSON.parse(number.Text)[props.lang]}</div>
                </div>
            </div>
        );
        return (
            <Fragment>{listItems}</Fragment>
        )}

    function MakeVisibleAll() {
        const MakeVisibleThisArr = stateArrayFAQ;
        for (let i = 0; i < Object.keys(stateArrayFAQ).length; i++) {
            MakeVisibleThisArr[Object.keys(stateArrayFAQ)[i]] = true;
        }
        ButtonInvestVisibleAllLet = 'InvestFAQButtonButtonAllDivActiveNo';
        ButtonInvestVisibleNoLet = 'InvestFAQButtonButtonAllDivActive';
        setstateArrayFAQ(MakeVisibleThisArr);
        setVisibleOpenButton(ButtonInvestVisibleAllLet);
        setVisibleCloseButton(ButtonInvestVisibleNoLet);
    }
    function MakeVisibleNo() {
        const MakeVisibleThisArr = stateArrayFAQ;
        for (let i = 0; i < Object.keys(stateArrayFAQ).length; i++) {
            MakeVisibleThisArr[Object.keys(stateArrayFAQ)[i]] = false;
        }
        ButtonInvestVisibleAllLet = 'InvestFAQButtonButtonAllDivActive';
        ButtonInvestVisibleNoLet = 'InvestFAQButtonButtonAllDivActiveNo';
        setstateArrayFAQ(MakeVisibleThisArr);
        setVisibleOpenButton(ButtonInvestVisibleAllLet);
        setVisibleCloseButton(ButtonInvestVisibleNoLet);
    }

    function MakeVisibleThis(idActive) {
        setRerender(!forRerender);

        const MakeVisibleThisArr = stateArrayFAQ;
        MakeVisibleThisArr[idActive] = !MakeVisibleThisArr[idActive];

        let check = false;
        let ButtonInvestVisibleAllLet = 'InvestFAQButtonButtonAllDivActive';
        let ButtonInvestVisibleNoLet = 'InvestFAQButtonButtonAllDivActive';
        for (let i = 0; i < Object.values(MakeVisibleThisArr).length; i++) {
            if (Object.values(MakeVisibleThisArr)[i]) {check = true}
        }
        if (!check) {ButtonInvestVisibleNoLet = 'InvestFAQButtonButtonAllDivActiveNo'}

        check = false;
        for (let i = 0; i < Object.values(MakeVisibleThisArr).length; i++) {
            if (Object.values(MakeVisibleThisArr)[i]) {check = true}
        }
        if (!check) {ButtonInvestVisibleAllLet = 'InvestFAQButtonButtonAllDivActiveNo'}
        setstateArrayFAQ(MakeVisibleThisArr);
        setVisibleOpenButton(ButtonInvestVisibleAllLet);
        setVisibleCloseButton(ButtonInvestVisibleNoLet);
    }
        return (
                <main className="InvestFAQ ">
                    <div className="InvestFAQIn ">
                        <div className="InvestFAQButtonButtonAll">
                            <div className={VisibleOpenButton} onClick={() => MakeVisibleAll()} role="button" tabIndex={0} onKeyPress={() => {}}><img alt='Ifyoudontseeimages' src={eyeopen} width='36px' height='24px'/><nobr>Open All</nobr> </div>
                            <div className={VisibleCloseButton} onClick={() => MakeVisibleNo()} role="button" tabIndex={0} onKeyPress={() => {}}><img alt='Ifyoudontseeimages' src={eyeclose} width='36px' height='24px'/> <nobr>Close All</nobr> </div>
                        </div>
                        <div className="InvestFAQPart">{FAQCategory(props.AllFAQCategories)}</div>
                    </div>
                </main>
        )}



export default InvestFAQElements
